module.exports = new __parcel__URL__("train_1_active.80408306.png").toString();